import {
  fork,
  put,
  all,
  call,
  takeLatest,
} from "redux-saga/effects";

import {
  getComplianceListSuccessful,
  getComplianceListFailure,
  clearAllComplianceMessagesSuccessful,
  getComplianceControlsSuccessful,
  getComplianceControlsFailure,
  getComplianceResourcesSuccessful,
  getComplianceResourcesFailure,
  createComplianceWorkloadSuccessful,
  createComplianceWorkloadFailure,
  editComplianceWorkloadSuccessful,
  editComplianceWorkloadFailure,
  deleteComplianceWorkloadSuccessful,
  deleteComplianceWorkloadFailure,
  initiateComplianceScanSuccessful,
  initiateComplianceScanFailure,
  initiateComplianceScan,
  getComplianceTagsSuccessful,
  getComplianceTagsFailure,
  getComplianceControlSectionsSuccessful,
  getComplianceControlSectionsFailure,
  downloadComplianceReportSuccessful,
  downloadComplianceReportFailure,
  downloadComplianceReport,
} from "./complianceSlice";

import {
  getComplianceList as getComplianceListApi,
  getComplianceControls as getComplianceControlsApi,
  getComplianceResourceList as getComplianceResourceListApi,
  createComplianceWorkload as createComplianceWorkloadApi,
  editComplianceWorkload as editComplianceWorkloadApi,
  deleteComplianceWorkload as deleteComplianceWorkloadApi,
  initiateComplianceScan as initiateComplianceScanApi,
  getComplianceTags as getComplianceTagsApi,
  getComplianceControlSections as getComplianceControlSectionsApi,
  downloadComplianceReport as downloadComplianceReportApi,
} from "../../helpers/auth_aws_helper";

function* getComplianceList({ payload }) {
  try {
    console.log("about to call *getComplianceList() with payload:", payload);
    const response = yield call(getComplianceListApi, payload);
    console.log("*getComplianceListApi() response: ", response);
    console.log("Response type:", typeof response);
    console.log("Response data:", response.data);
    console.log("Response data type:", typeof response.data);

    if (response && response.status === 200) {
      // The response data is already in the correct format
      yield put(getComplianceListSuccessful(response));
    } else {
      let message = "An error occurred while fetching compliance data";
      if (response.message) {
        message = response.message;
      } else if (response.data) {
        message = typeof response.data === 'string' ? response.data : response.data.message || response.data.error || JSON.stringify(response.data);
      }
      yield put(getComplianceListFailure({ message }));
    }
  } catch (error) {
    console.error("Error in getComplianceList saga:", error);
    let message = "An error occurred while fetching compliance data";
    
    if (error.message) {
      message = error.message;
    } else if (error.response?.data) {
      message = typeof error.response.data === 'string' ? error.response.data : error.response.data.message || error.response.data.error || JSON.stringify(error.response.data);
    }
    
    yield put(getComplianceListFailure({ message }));
  }
}

function* getComplianceControls({ payload }) {
  try {
    console.log("about to call *getComplianceControls() with payload:", payload);
    const response = yield call(getComplianceControlsApi, payload);
    console.log("*getComplianceControlsApi() response: ", response);
    console.log("Response type:", typeof response);
    console.log("Response data:", response.data);
    console.log("Response data type:", typeof response.data);

    if (response && response.status === 200) {
      delete response.status;
      yield put(getComplianceControlsSuccessful(response));
    } else {
      let message = "An error occurred while fetching compliance controls";
      if (response.message) {
        message = response.message;
      } else if (response.data) {
        message = typeof response.data === 'string' ? response.data : response.data.message || response.data.error || JSON.stringify(response.data);
      }
      yield put(getComplianceControlsFailure({ message }));
    }
  } catch (error) {
    console.error("Error in getComplianceControls saga:", error);
    let message = "An error occurred while fetching compliance controls";
    
    if (error.message) {
      message = error.message;
    } else if (error.response?.data) {
      message = typeof error.response.data === 'string' 
        ? error.response.data 
        : error.response.data.message || error.response.data.error || JSON.stringify(error.response.data);
    } else if (error.response?.status === 500) {
      message = "Internal Server Error: Please try again later";
    }
    
    yield put(getComplianceControlsFailure({ message }));
  }
}

function* getComplianceResources({ payload }) {
  try {
    console.log("about to call *getComplianceResources() with payload:", payload);
    const response = yield call(getComplianceResourceListApi, payload);
    console.log("*getComplianceResourceListApi() response: ", response);
    // No more response.data, just log response
    // Accept any object as a successful response
    if (response && typeof response === 'object') {
      yield put(getComplianceResourcesSuccessful(response));
    } else {
      let message = "An error occurred while fetching compliance resources";
      if (response && response.message) {
        message = response.message;
      } else if (typeof response === 'string') {
        message = response;
      }
      yield put(getComplianceResourcesFailure({ message }));
    }
  } catch (error) {
    console.error("Error in getComplianceResources saga:", error);
    let message = "An error occurred while fetching compliance resources";
    if (error.message) {
      message = error.message;
    } else if (error.response?.data) {
      message = typeof error.response.data === 'string' 
        ? error.response.data 
        : error.response.data.message || error.response.data.error || JSON.stringify(error.response.data);
    } else if (error.response?.status === 500) {
      message = "Internal Server Error: Please try again later";
    }
    yield put(getComplianceResourcesFailure({ message }));
  }
}

function* clearAllComplianceMessages() {
  console.log("Saga: clear All Compliance Messages");
  yield put(clearAllComplianceMessagesSuccessful());
}

function* createComplianceWorkload({ payload }) {
  try {
    const response = yield call(createComplianceWorkloadApi, payload);
    if (response && response.status === 200) {
      yield put(createComplianceWorkloadSuccessful(response));
    } else {
      let message = "An error occurred while creating compliance workload";
      if (response.message) {
        message = response.message;
      } else if (response.data) {
        message = typeof response.data === 'string' ? response.data : response.data.message || response.data.error || JSON.stringify(response.data);
      }
      yield put(createComplianceWorkloadFailure({ message }));
    }
  } catch (error) {
    let message = "An error occurred while creating compliance workload";
    if (error.message) {
      message = error.message;
    } else if (error.response?.data) {
      message = typeof error.response.data === 'string' ? error.response.data : error.response.data.message || error.response.data.error || JSON.stringify(error.response.data);
    }
    yield put(createComplianceWorkloadFailure({ message }));
  }
}

function* editComplianceWorkload({ payload }) {
  try {
    const response = yield call(editComplianceWorkloadApi, payload);
    if (response && response.status === 200) {
      yield put(editComplianceWorkloadSuccessful(response));
    } else {
      let message = "An error occurred while editing compliance workload";
      if (response.message) {
        message = response.message;
      } else if (response.data) {
        message = typeof response.data === 'string' ? response.data : response.data.message || response.data.error || JSON.stringify(response.data);
      }
      yield put(editComplianceWorkloadFailure({ message }));
    }
  } catch (error) {
    let message = "An error occurred while editing compliance workload";
    if (error.message) {
      message = error.message;
    } else if (error.response?.data) {
      message = typeof error.response.data === 'string' ? error.response.data : error.response.data.message || error.response.data.error || JSON.stringify(error.response.data);
    }
    yield put(editComplianceWorkloadFailure({ message }));
  }
}

function* deleteComplianceWorkload({ payload }) {
  try {
    const response = yield call(deleteComplianceWorkloadApi, payload);
    if (response && response.status === 200) {
      yield put(deleteComplianceWorkloadSuccessful(response));
    } else {
      let message = "An error occurred while deleting compliance workload";
      if (response.message) {
        message = response.message;
      } else if (response.data) {
        message = typeof response.data === 'string' ? response.data : response.data.message || response.data.error || JSON.stringify(response.data);
      }
      yield put(deleteComplianceWorkloadFailure({ message }));
    }
  } catch (error) {
    let message = "An error occurred while deleting compliance workload";
    if (error.message) {
      message = error.message;
    } else if (error.response?.data) {
      message = typeof error.response.data === 'string' ? error.response.data : error.response.data.message || error.response.data.error || JSON.stringify(error.response.data);
    }
    yield put(deleteComplianceWorkloadFailure({ message }));
  }
}

function* initiateComplianceScanSaga({ payload }) {
  try {
    const response = yield call(initiateComplianceScanApi, payload);
    if (response && response.status === 200) {
      yield put(initiateComplianceScanSuccessful(response));
    } else {
      let message = "An error occurred while initiating compliance scan";
      if (response.message) {
        message = response.message;
      } else if (response.data) {
        message = typeof response.data === 'string' ? response.data : response.data.message || response.data.error || JSON.stringify(response.data);
      }
      yield put(initiateComplianceScanFailure({ message }));
    }
  } catch (error) {
    let message = "An error occurred while initiating compliance scan";
    if (error.message) {
      message = error.message;
    } else if (error.response?.data) {
      message = typeof error.response.data === 'string' ? error.response.data : error.response.data.message || error.response.data.error || JSON.stringify(error.response.data);
    }
    yield put(initiateComplianceScanFailure({ message }));
  }
}

function* getComplianceTags({ payload }) {
  try {
    console.log("about to call *getComplianceTags() with payload:", payload);
    const response = yield call(getComplianceTagsApi, payload);
    console.log("*getComplianceTagsApi() response: ", response);

    if (response && response.status === 200) {
      yield put(getComplianceTagsSuccessful(response));
    } else {
      let message = "An error occurred while fetching compliance tags";
      if (response.message) {
        message = response.message;
      } else if (response.data) {
        message = typeof response.data === 'string' ? response.data : response.data.message || response.data.error || JSON.stringify(response.data);
      }
      yield put(getComplianceTagsFailure({ message }));
    }
  } catch (error) {
    console.error("Error in getComplianceTags saga:", error);
    let message = "An error occurred while fetching compliance tags";
    
    if (error.message) {
      message = error.message;
    } else if (error.response?.data) {
      message = typeof error.response.data === 'string' 
        ? error.response.data 
        : error.response.data.message || error.response.data.error || JSON.stringify(error.response.data);
    }
    
    yield put(getComplianceTagsFailure({ message }));
  }
}

function* getComplianceControlSections({ payload }) {
  try {
    console.log("about to call *getComplianceControlSections() with payload:", payload);
    const response = yield call(getComplianceControlSectionsApi, payload);
    console.log("*getComplianceControlSectionsApi() response: ", response);
    console.log("Response type:", typeof response);
    console.log("Response data:", response.data);
    console.log("Response data type:", typeof response.data);

    if (response && response.status === 200) {
      delete response.status;
      yield put(getComplianceControlSectionsSuccessful({ ...response, forRunId: payload?.runId || null }));
    } else {
      let message = "An error occurred while fetching compliance control sections";
      if (response.message) {
        message = response.message;
      } else if (response.data) {
        message = typeof response.data === 'string' ? response.data : response.data.message || response.data.error || JSON.stringify(response.data);
      }
      yield put(getComplianceControlSectionsFailure({ message }));
    }
  } catch (error) {
    console.error("Error in getComplianceControlSections saga:", error);
    let message = "An error occurred while fetching compliance control sections";
    
    if (error.message) {
      message = error.message;
    } else if (error.response?.data) {
      message = typeof error.response.data === 'string' 
        ? error.response.data 
        : error.response.data.message || error.response.data.error || JSON.stringify(error.response.data);
    } else if (error.response?.status === 500) {
      message = "Internal Server Error: Please try again later";
    }
    
    yield put(getComplianceControlSectionsFailure({ message }));
  }
}

function* downloadComplianceReportSaga({ payload }) {
  try {
    const response = yield call(downloadComplianceReportApi, payload);

    if (response && response.status === 200 && response.downloadUrl) {
      yield put(downloadComplianceReportSuccessful(response.downloadUrl));
    } else {
      let message = "An error occurred while downloading compliance report";
      if (response?.message) {
        message = response.message;
      } else if (response?.data) {
        message = typeof response.data === 'string' ? response.data : response.data.message || response.data.error || JSON.stringify(response.data);
      }
      yield put(downloadComplianceReportFailure({ message }));
    }
  } catch (error) {
    let message = "An error occurred while downloading compliance report";
    if (error.message) {
      message = error.message;
    } else if (error.response?.data) {
      message = typeof error.response.data === 'string' ? error.response.data : error.response.data.message || error.response.data.error || JSON.stringify(error.response.data);
    }
    yield put(downloadComplianceReportFailure({ message }));
  }
}

export function* watchCompliance() {
  yield takeLatest("compliance/getComplianceList", getComplianceList);
  yield takeLatest("compliance/getComplianceControls", getComplianceControls);
  yield takeLatest("compliance/getComplianceResources", getComplianceResources);
  yield takeLatest("compliance/clearAllComplianceMessages", clearAllComplianceMessages);
  yield takeLatest("compliance/createComplianceWorkload", createComplianceWorkload);
  yield takeLatest("compliance/editComplianceWorkload", editComplianceWorkload);
  yield takeLatest("compliance/deleteComplianceWorkload", deleteComplianceWorkload);
  yield takeLatest("compliance/initiateComplianceScan", initiateComplianceScanSaga);
  yield takeLatest("compliance/getComplianceTags", getComplianceTags);
  yield takeLatest("compliance/getComplianceControlSections", getComplianceControlSections);
  yield takeLatest("compliance/downloadComplianceReport", downloadComplianceReportSaga);
}

export function* complianceSaga() {
  yield all([fork(watchCompliance)]);
}

export default complianceSaga;
